module.exports = __webpack_public_path__ + "img/title-page-img.39a3b7c4.png";